<template>
    <!--  <div class="component-container">-->
    <!--    <div class="chart-canvas" id="valume"></div>-->
    <!--    <img class="banner" src="@/assets/images/bg-pic.png" alt="" />-->
    <!--  </div>-->
    <div class="component-container">
        <div class="chart-canvas" id="valume"></div>
        <img class="banner" src="@/assets/images/bg-pic.png" alt="" />
    </div>
</template>

<script>
import * as echarts from "echarts";

import { mapState } from "vuex";
export default {
    data () {
        return {
            getInList: [], //进货量列表
            getOutList: [], //出货量列表
            dateTypeList: [], //日期类型
            startVal: 0, //区域缩放的起点值
            endVal: 5, //区域缩放的起点值
            timeId: null, //定时器的id
            // data: "",

            myChart: undefined,
        };
    },
    async mounted () {
        this.initChart();
    },
    computed: {
        ...mapState(["dateType"]),
    },
    watch: {
        dateType (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getData();
            }
        },
    },
    destroyed () {
        //清除定时器
        clearInterval(this.timeId);
    },
    methods: {
        // 初始化表
        async initChart () {
            const chartDom = document.getElementById("valume");
            this.myChart = echarts.init(chartDom);
            await this.getData();
            this.startInterval();
            this.myChart.on("mouseover", () => {
                clearInterval(this.timeId);
            });
            this.myChart.on("mouseout", () => {
                this.startInterval();
            });
        },
        //获取后台的数据
        async getData () {
            await this.$http
                .get("/screen/getVehicleStatistics?type=" + this.dateType, {})
                .then((response) => {
                    if (response.status == 200) {
                        this.getInList = [];
                        this.getOutList = [];
                        this.dateTypeList = [];
                        const inGoodsList = response.data.inList;
                        const outGoodsLis = response.data.outList;
                        inGoodsList.forEach((element) => {
                            if (this.dateType == 1 && new Date().getHours() >= Number(element.time)) {  //日
                                this.getInList.push(element.result);
                                this.dateTypeList.push(element.time);
                            }
                            if (this.dateType == 2 && new Date().getDate() >= Number(element.time)) {  //月
                                this.getInList.push(element.result);
                                this.dateTypeList.push(element.time);
                            }
                            if (this.dateType == 3 && new Date().getMonth() + 1 >= Number(element.time)) {  //年
                                this.getInList.push(element.result);
                                this.dateTypeList.push(element.time);
                            }
                        });
                        outGoodsLis.forEach((element) => {
                            if (this.dateType == 1 && new Date().getHours() >= Number(element.time)) {  //日
                                this.getOutList.push(element.result);
                            }
                            if (this.dateType == 2 && new Date().getDate() >= Number(element.time)) {  //月
                                this.getOutList.push(element.result);
                            }
                            if (this.dateType == 3 && new Date().getMonth() + 1 >= Number(element.time)) {  //年
                                this.getOutList.push(element.result);
                            }
                        });
                    }
                });
            this.startVal = 0;
            this.endVal = 5;
            this.showValumeEcharts();
        },
        showValumeEcharts () {
            const option = {
                title: {
                    text: "过磅车辆进出量",
                    left: "17",
                    top: "6",
                    textStyle: {
                        color: "#00C4FF",
                    },
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {},
                    },
                },
                legend: {
                    data: ["进入量", "驶出量"],
                    top: 36,
                    icon: "roundRect",
                    textStyle: {
                        //图例文字的样式
                        color: "#0CFEEE",
                        fontSize: 20,
                    },
                },
                toolbox: {},
                grid: {
                    left: "15%",
                    right: "12%",
                    bottom: "12%",
                    top: "34%",
                },
                xAxis: [
                    {
                        type: "category",
                        name: "日期",
                        boundaryGap: false,
                        data: this.dateTypeList,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#fff", //y轴的刻度线颜色
                                fontSize: 16,
                            },
                        },
                        nameTextStyle: {
                            color: "#0CFEEE", //坐标轴name颜色
                            fontSize: 16,
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        splitLine: false,
                        show: true,
                        axisLine: { show: false },
                        axisTick: { show: false },
                        name: "进出量(次)",
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#fff", //y轴的刻度线颜色
                                fontSize: 17,
                            },
                        },
                        nameTextStyle: {
                            color: "#0CFEEE", //坐标轴name颜色
                            fontSize: 16,
                        },
                    },
                ],
                dataZoom: {
                    show: false,
                    startValue: this.startVal,
                    endValue: this.endVal,
                },
                series: [
                    {
                        name: "进入量",
                        type: "line",
                        areaStyle: {},
                        emphasis: {
                            focus: "series",
                        },
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(117, 81, 190, 1)',
                                    },
                                    {
                                        offset: 0.5,
                                        color: 'rgba(117, 81, 190, 1)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(117, 81, 190, 1)',
                                    },
                                ]),
                                lineStyle: {
                                    width: 2, //设置线条粗细
                                },
                            },
                        },
                        data: this.getInList,
                    },
                    {
                        name: "驶出量",
                        type: "bar",
                        areaStyle: {},
                        emphasis: {
                            focus: "series",
                        },
                        barWidth: 20, //柱图宽度
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(7, 180, 175, 0.5)',
                                    },
                                    {
                                        offset: 0.5,
                                        color: 'rgba(7, 180, 175, 0.5)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(7, 180, 175, 0)',
                                    },
                                ]),
                            },
                        },
                        data: this.getOutList,
                    },
                ],
            };
            option &&
                this.myChart.setOption(option);
            this.myChart.resize()
        },
        startInterval () {
            // 判断定时器是否存在
            if (this.timeId) {
                clearInterval(this.timeId);
            }
            this.timeId = setInterval(() => {
                this.startVal++;
                this.endVal++;
                if (this.endVal > this.dateTypeList.length - 1) {
                    this.startVal = 0;
                    this.endVal = 5;
                }
                this.showValumeEcharts();
            }, 5000);
        },
    },
};
</script>

<style scoped></style>
